import React, { memo } from 'react';

const EntityCrudWrapper = ({ children }) => {
    return <div className="entity-crud-wrapper">{children}</div>;
};

export default memo(EntityCrudWrapper);
